var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHorizontalLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-8.00 -7.55 455.10 158.85",
    width: 455,
    height: 159,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6.5) scale(1.9)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 42,
    width: 30,
    height: 30,
    rx: 9,
    fill: "#E0661A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 38,
    width: 30,
    height: 30,
    rx: 9,
    fill: "#FF8A3D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 42,
    width: 30,
    height: 30,
    rx: 9,
    fill: "#261C66"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 38,
    width: 30,
    height: 30,
    rx: 9,
    fill: "#3A2D8C"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(14 39 15)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 4,
    width: 30,
    height: 30,
    rx: 9,
    fill: "#E8A600"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 0,
    width: 30,
    height: 30,
    rx: 9,
    fill: "#FFC93C"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199.25 88.65 180.65 77.1 214.4 42.599999999999994Q222.2 42.599999999999994 226.92499999999998 46.05Q231.64999999999998 49.5 231.64999999999998 54.75Q231.64999999999998 59.25 228.5 62.7Q225.35 66.15 218.75 71.85ZM181.85 80.69999999999999 202.4 71.85 234.05 103.35Q233.45 110.25 230.0 114.07499999999999Q226.55 117.89999999999999 220.1 117.89999999999999Q215.45 117.89999999999999 211.625 115.57499999999999Q207.8 113.25 203.45 107.7ZM163.1 76.94999999999999H188.6V116.39999999999999Q186.95 116.85 183.875 117.3Q180.8 117.75 177.2 117.75Q169.85 117.75 166.475 115.19999999999999Q163.1 112.64999999999999 163.1 105.75ZM188.6 90.3H163.1V18.75Q164.75 18.299999999999997 167.825 17.85Q170.9 17.400000000000006 174.5 17.400000000000006Q182.0 17.400000000000006 185.3 19.875Q188.6 22.349999999999994 188.6 29.400000000000006ZM242.0 87.6V77.69999999999999H267.5V87.6Q267.5 93.6 270.575 96.3Q273.65 99.0 279.2 99.0Q282.65 99.0 284.9 98.4Q287.15 97.8 288.2 97.2V77.69999999999999H313.7V100.95Q313.7 104.7 312.125 107.475Q310.54999999999995 110.25 307.4 112.2Q302.15 115.5 294.875 117.225Q287.59999999999997 118.95 279.05 118.95Q268.25 118.95 259.85 115.725Q251.45 112.5 246.725 105.6Q242.0 98.7 242.0 87.6ZM313.7 84.15H288.2V43.95Q289.84999999999997 43.5 292.92499999999995 43.05Q296.0 42.599999999999994 299.59999999999997 42.599999999999994Q307.09999999999997 42.599999999999994 310.4 45.074999999999996Q313.7 47.55 313.7 54.6ZM267.5 84.15H242.0V43.95Q243.64999999999998 43.5 246.72499999999997 43.05Q249.79999999999998 42.599999999999994 253.39999999999998 42.599999999999994Q260.9 42.599999999999994 264.2 45.074999999999996Q267.5 47.55 267.5 54.6ZM366.8 41.400000000000006Q376.7 41.400000000000006 384.79999999999995 45.75Q392.9 50.099999999999994 397.625 58.64999999999999Q402.35 67.19999999999999 402.35 79.8Q402.35 92.25 397.32500000000005 101.025Q392.3 109.8 383.15 114.375Q374.0 118.95 361.7 118.95Q351.8 118.95 344.9 116.55Q338.0 114.14999999999999 333.2 110.85Q330.05 108.6 328.32500000000005 105.6Q326.6 102.6 326.6 98.85V52.05H351.95V96.6Q353.6 97.5 355.925 98.175Q358.25 98.85 361.4 98.85Q368.15 98.85 372.2 93.975Q376.25 89.1 376.25 79.8Q376.25 70.19999999999999 372.425 65.77499999999999Q368.6 61.35 362.0 61.35Q357.5 61.35 354.05 63.0Q350.6 64.65 348.05 66.6V46.05Q351.5 44.25 356.3 42.825Q361.1 41.400000000000006 366.8 41.400000000000006ZM352.1 58.2H326.6V18.75Q328.25 18.299999999999997 331.325 17.85Q334.4 17.400000000000006 338.0 17.400000000000006Q345.5 17.400000000000006 348.8 19.875Q352.1 22.349999999999994 352.1 29.400000000000006ZM411.2 23.400000000000006Q411.2 17.700000000000003 415.1 13.800000000000004Q419.0 9.900000000000006 425.15 9.900000000000006Q431.3 9.900000000000006 435.20000000000005 13.800000000000004Q439.1 17.700000000000003 439.1 23.400000000000006Q439.1 28.950000000000003 435.20000000000005 32.925000000000004Q431.3 36.900000000000006 425.15 36.900000000000006Q419.0 36.900000000000006 415.1 32.925000000000004Q411.2 28.950000000000003 411.2 23.400000000000006ZM412.4 76.94999999999999H437.9V116.39999999999999Q436.25 116.85 433.175 117.3Q430.1 117.75 426.5 117.75Q419.15 117.75 415.775 115.19999999999999Q412.4 112.64999999999999 412.4 105.75ZM437.9 90.3H412.4V44.7Q414.05 44.25 417.125 43.8Q420.2 43.349999999999994 423.8 43.349999999999994Q431.3 43.349999999999994 434.6 45.824999999999996Q437.9 48.3 437.9 55.35Z",
    fill: "#1F1B3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalLogo);
export default __webpack_public_path__ + "static/media/horizontal-logo.07ff03789e1e47f3633958e0d35c4f65.svg";
export { ForwardRef as ReactComponent };